<template>
  <div v-show="showList" :key="componentKey">
    <form id="client-filter">
      <div class="form-group flex-div">
        <div class="autocomplete-box">
          <WjMultiAutoComplete
            :placeholder="$t('pages.clientConfiguration.clientName')"
            :initialized="initMultiAutoCompletes"
            :displayMemberPath="'externalId'"
            :itemsSource="clients"
            :selectedIndex="-1"
            :selectedItemsChanged="selectedItemsChanged"
            :beginsWithSearch="true"
          >
          </WjMultiAutoComplete>
        </div>
        <div v-if="$jwt.hasRole('dm-super-admin')" class="page-actions" >
          <button class="btn btn-danger" type="button" v-on:click="resetAllClients">Reset all</button>
        </div>
      </div>
    </form>
    <section class="content main-client-list">
      <div class="row" v-if="clients">
        <div
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
          v-for="client of getClientFiltredList"
          :key="client"
        >
          <card
            :title="`${client.externalId}  ${getStatusEnum(client.status)}`"
            :styles="'overflow-none'"
            :fullScreen="false"
            :isDisabled="client.status == 'Active' ? false : true"
            :customTheme="getCardTheme(client)"
            :actions="computeClientActions(client)"
            :id="client.externalId"
            @onBtnClicked="onBtnClicked"
          >
            <template v-slot:card-drop-down> </template>

            <template v-slot:card-body-title> </template>

            <template v-slot:card-body-container>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <ul class="client-fa-ul">
                      <li><i class="scf-keyCloak"></i> {{ client.name }}</li>
                      <li><i class="scf-fuseau"></i> {{ client.timezone }}</li>
                      <li><i class="scf-langue"></i> {{ client.culture }}</li>
                      <li>
                        <i class="scf-RGPD"></i>
                        {{ client.gdpr ? "Oui" : "Non" }}
                      </li>
                      <li>
                        <i class="scf-provider"></i> {{ client.apiCurve }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:card-footer>
              <div class="con-footer">
                <span
                  class="sf-tags"
                  :style="{ backgroundColor: service.color }"
                  v-for="service in (client?.services || []).slice(0, 5)"
                  :key="service"
                  >{{ service.name }}</span
                >
                <span class="sf-tags tag-more" v-if="(client?.services || []).length > 5"
                  >...</span
                >
              </div>
            </template>
          </card>
        </div>
      </div>
      <h5 v-if="!clients.length && reponseInjected">
        <center>{{ $t("pages.clientConfiguration.noReachableClient") }}</center>
      </h5>
    </section>
  </div>
  <section>
    <clientDetails
      v-show="chosenClient != null && showClientDetails && !showList"
      :client="chosenClient"
      @closeDetails="closeDetails"
    />

    <clientEdit
      v-if="chosenClient && chosenClient != null && showClientEdit && !showList"
      :client="chosenClient"
      @closeEdit="closeEdit"
      @client-updated="clientUpdated"
    />

  </section>
</template>

<script>
const themeSettings = {Migrating: {headerBgColor: "#efefef", bodyBgColor: "#efefef", footerBgColor: "#efefef"}, DoubleRun: {headerBgColor: "#f0f4fa", bodyBgColor: "#f0f4fa", footerBgColor: "#f0f4fa"}};

import { defineComponent } from "vue";
import card from "@supervision/vue-components/components/Card.vue";
import ClientService from "../../services/ClientService";
import "@grapecity/wijmo.vue2.core";
import { WjMultiAutoComplete } from "@grapecity/wijmo.vue2.input";
import "@grapecity/wijmo.styles/wijmo.css";
import clientDetails from "./Details.vue";
import clientEdit from "./Edit.vue";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ClientList",
  inject: ["accessToken"],
  components: {
    card,
    WjMultiAutoComplete,
    clientDetails,
    clientEdit,
  },
  props: {
    tabClicked: {
      type: Number,
      default: 1,
    },
    customTheme: {
      type: Object,
      default: () => ({
        headerBgColor: "#efefef",
        bodyBgColor: "#efefef",
        footerBgColor: "#efefef",
      })
    },
  },
  watch: {
    tabClicked: function (newVal) {
      if (newVal == 1) {
        // Parent tab 1 was clicked
        this.getClients(); // Refresh the clients list
      }
    },
     currentScope(newVal) {
        if (newVal) {
          this.clientService = new ClientService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.clientService = new ClientService(newVal, this.currentScope); 
        }
      },
  },
  data() {
    return {
      componentKey: 0,
      clients: [],
      clientService: null,
      currentScope: null,
      reponseInjected: false,
      theMultiAutoComplete: [],
      selectedItems: [],
      showList: true,
      chosenClient: null,
      showClientDetails: false,
      showClientEdit: false,
      clientActions: [
        { icon: 'scf-edit', backValue: 'editCard' },
        { icon: 'scf-Information', backValue: 'moreInfoCard' },
      ],
    };
  },
  computed: {
    culture() {
      return this.$i18n.locale;
    },
    getClientFiltredList() {
      if (this.selectedItems.length >= 1) {
        return this.selectedItems;
      }
      return this.clients;
    },
  },
  methods: {
    getCardTheme(client) {
      return themeSettings[client.status] || null;
    },
    getStatusEnum(status) {
      if(status == "Active") return "";
      return `(${this.$t(`pages.Client.statusEnum.${status.toUpperCase()}`)})`;
    },
    computeClientActions(client) {
      if (client && client.externalId.toUpperCase() === "COMMONSTOCK") {
        return this.clientActions.filter(ca => ca.backValue !== "resetClientData");
      }
      return this.clientActions;
    },
    resetAllClients() {
      Swal.fire({
          title: this.$t("pages.clientConfiguration.confirmResetForAll"),
          text: this.$t("pages.clientConfiguration.allResetDetails"),
          icon: "warning",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: this.$t("common.confirm"),
          denyButtonText: this.$t("common.cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({title: this.$t("pages.clientConfiguration.resetingDataForAll")});
            Swal.showLoading();
            this.clientService.resetAllClients()
            .then(res => {
              console.log('the result from server: ', res);
              if (res && res.statusCode && res.statusCode == 200) {
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  title: this.$t("pages.clientConfiguration.resetSuccess"),
                  text: this.$t("pages.clientConfiguration.resetAllSuccessText"),
                  confirmButtonText: 'OK'
                });
              }
              else if (res && res.statusCode && res.statusCode == 207 && res.data) {
                Swal.close();
                let htmlContent = `<div style="flex-direction: column;display: flex;align-items: baseline;">`;
                for(const clientResult of res.data) {
                  const icon = clientResult.isSuccess ? `<i style="color:green;">&#10003;</i>` : `<i style="color:red;">&#9888;</i>`;
                  htmlContent += `<div> ${icon} ${clientResult.client} ${!clientResult.isSuccess ? "&rarr; " + clientResult.exception?.MessageText : ""}</div>`;
                }
                htmlContent += `</div>`;
                Swal.fire({
                  icon: 'error',
                  title: this.$t("pages.clientConfiguration.resetFailed"),
                  html: htmlContent,
                  confirmButtonText: 'OK'
                });
              }
              else {
                Swal.close();
                Swal.fire({
                  icon: 'error',
                  title: this.$t("pages.clientConfiguration.resetFailed"),
                  text: this.$t("pages.clientConfiguration.resetAllFailedText"),
                  confirmButtonText: 'OK'
                });
              }
            });
          }
        });
    },
    resetClientData(client) {
      if (client) {
        Swal.fire({
          title: this.$t("pages.clientConfiguration.confirmResetForClient", {client: client.externalId}),
          text: this.$t("pages.clientConfiguration.clientResetDetails", {client: client.externalId}),
          icon: "warning",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: this.$t("common.confirm"),
          denyButtonText: this.$t("common.cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({title: this.$t("pages.clientConfiguration.resetingDataFor", {client: client.externalId})});
            Swal.showLoading();
            this.clientService.resetClientData(client.externalId)
            .then(res => {
              if (typeof res === 'boolean' && res) {
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  title: this.$t("pages.clientConfiguration.resetSuccess"),
                  text: this.$t("pages.clientConfiguration.resetSuccessText", {client: client.externalId}),
                  confirmButtonText: 'OK'
                });
              } else {
                Swal.close();
                Swal.fire({
                  icon: 'error',
                  title: this.$t("pages.clientConfiguration.resetFailed"),
                  text: this.$t("pages.clientConfiguration.resetFailedText", {client: client.externalId}),
                  confirmButtonText: 'OK'
                });
              }
            });
          }
        });
      }
    },
    getClients() {
      this.clientService
        .getClients()
        .then((response) => {

          this.clients = response;
          this.reponseInjected = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clientUpdated(client) {
      let auxList = [];
      for (let clientInList of this.clients) {
        if (clientInList.externalId == client.externalId) {
          auxList.push(client);
        } else {
          auxList.push(clientInList);
        }
      }
      this.clients = auxList;
      this.closeEdit();
    },
    initMultiAutoCompletes: function (complete) {
      this.theMultiAutoComplete = complete;
    },
    selectedItemsChanged: function (eventArgs) {
      this.selectedItems = [];
      this.selectedItems = eventArgs.selectedItems;
    },
    onBtnClicked: function (payload) {
      var externalId = payload.id;
      var actionToDo = payload.backValue;
      const client = this.clientService.getClientByExternalId(
          this.clients,
          externalId
      );

      switch (actionToDo) {
        case "resetClientData":
          if (client) {
            this.resetClientData(client);
          }
          break;
        case "moreInfoCard":
          if (client) {
            this.chosenClient = client;
            this.showClientDetails = true;
            this.showList = false;
          }
          break;
        case "editCard":
          if (client) {
            this.chosenClient = client;
            this.showClientEdit = true;
            this.showList = false;
          }
          break;
        case "turnOffCard":
          alert("disactive client");
          break;

        default:
          break;
      }
    },
    closeDetails: function () {
      this.showClientDetails = false;
      this.showList = true;
    },
    closeEdit: function () {
      this.showClientEdit = false;
      this.showList = true;
    },
  },
  mounted() {
    if (this.$jwt.hasRole('dm-super-admin')) {
      this.clientActions.unshift({
        icon: 'scf-refresh',
        backValue: 'resetClientData',
      });
    }
    this.getClients();
  },
  created() {
    this.clientService = new ClientService(this.$jwt.token, this.$jwt.scope);
    this.currentScope = this.$jwt.scope;
  }
});
</script>

<style scoped src="../../assets/css/client.css"></style>
